<template>
    <div v-if="modelValue" class="container">
        <div v-if="isLoadingList" class="d-flex align-items-center" style="gap: 5px">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <span>{{ $t('loading.products') }}</span>
        </div>
        <div v-else class="custom-table-items" @scroll="handleScroll">
            <table class="table">
                <thead class="thead-light">
                    <tr>
                        <!-- <th class="table-checkbox"><input class="form-check-input" type="checkbox" :checked="selectedRows.length === list.data.length" @change="SET_SELECTED_ALL_ROWS()" /></th> -->
                        <template v-for="column in getColumns">
                            <th v-if="!['image'].includes(column.key) && column.visible" :key="column.key">
                                {{ $t(`views.products.columns.${column.key}`) }}
                            </th>
                            <th v-if="['image'].includes(column.key) && column.visible" :key="column.key" class="text-center">{{ $t(`views.products.columns.${column.key}`) }}</th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr></tr>
                    <tr v-for="(item, index) in list.data" :key="index" class="bg-white">
                        <!-- <td class="table-checkbox">
                        <input :value="item.id" :checked="selectedRows.indexOf(item.id) > -1" @change="SET_SELECTED_ROW(item.id)" class="form-check-input" type="checkbox" />
                    </td> -->
                        <template v-for="column in columns">
                            <td v-if="column.key === 'image' && column.visible" :key="column.key" class="text-center" style="max-width: 75px">
                                <ImagePlaceholder :img_url="item.product?.img_url" style="height: 60px" />
                            </td>
                            <td v-if="column.key === 'productInfo' && column.visible" :key="column.key" style="min-width: 260px">
                                <div class="d-flex flex-column">
                                    <Popper class="popp" hover arrow>
                                        <template #content>{{ item.product.title }}</template>
                                        <div class="text-ellipsis title">
                                            {{ item.product.title }}
                                        </div>
                                    </Popper>
                                    <div class="d-flex" style="gap: 5px">
                                        <span>ASIN:</span>
                                        <InventoryClipboard :asin="item.product.asin" />
                                    </div>
                                    <div class="d-flex" style="gap: 5px">
                                        <span>SKU:</span>
                                        <InventoryClipboard type="sku" :asin="item.product.asin" :sku="item.product.sku" />
                                    </div>
                                </div>
                            </td>
                            <td v-if="column.key === 'quantity' && column.visible" :key="column.key">{{ item.order?.quantity_ordered ? item.order.quantity_ordered.toLocaleString() : '-' }}</td>
                            <td v-if="column.key === 'refund' && column.visible" :key="column.key">
                                <div v-if="item.calculated.refunded_quantity" class="d-flex" style="gap: 5px">
                                    {{ item.calculated.refunded_quantity }}
                                </div>
                                <template v-else>-</template>
                            </td>
                            <td v-if="column.key === 'price' && column.visible" :key="column.key">
                                <div v-if="item.calculated.sell_price" class="d-flex" style="gap: 5px">
                                    <span>{{ item.calculated.currency }}</span>
                                    <strong>{{ formatNumber(item.calculated.sell_price) }}</strong>
                                </div>
                                <template v-else>-</template>
                            </td>
                            <td v-if="column.key === 'feesTaxes' && column.visible" :key="column.key">
                                <div v-if="item.calculated.total_fee_tax" class="d-flex" style="gap: 5px">
                                    <span>{{ item.calculated.currency }}</span>
                                    <strong>{{ formatNumber(item.calculated.total_fee_tax) }}</strong>
                                </div>
                                <template v-else>-</template>
                            </td>
                            <td v-if="column.key === 'cog' && column.visible" :key="column.key">
                                <div v-if="item.calculated.cost_of_goods" class="d-flex" style="gap: 5px">
                                    <span>{{ item.calculated.currency }}</span>
                                    <strong>{{ formatNumber(item.calculated.cost_of_goods) }}</strong>
                                </div>
                                <template v-else>-</template>
                            </td>
                            <td v-if="column.key === 'profitMargin' && column.visible" :key="column.key">
                                <div v-if="item.calculated.profit_margin" class="d-flex" style="gap: 5px">
                                    <span>{{ item.calculated.currency }}</span>
                                    <strong :class="item.calculated?.profit_margin > 0 ? 'text-success' : !item.calculated?.profit_margin ? 'text-secondary' : 'text-danger'">{{ formatPercentage(item.calculated.profit_margin) }}</strong>
                                </div>
                                <template v-else>-</template>
                            </td>
                            <td v-if="column.key === 'profit' && column.visible" :key="column.key">
                                <div v-if="item.calculated.profit" class="d-flex" style="gap: 5px">
                                    <span>{{ item.calculated.currency }}</span>
                                    <strong :class="item.calculated?.profit > 0 ? 'text-success' : !item.calculated?.profit ? 'text-secondary' : 'text-danger'">{{ formatNumber(item.calculated.profit) }}</strong>
                                </div>
                                <template v-else>-</template>
                            </td>
                            <td v-if="column.key === 'profitPercent' && column.visible" :key="column.key">
                                <div class="d-flex align-items-center" style="gap: 5px" :class="item.calculated?.roi > 0 ? 'text-success' : !item.calculated?.roi ? 'text-secondary' : 'text-danger'">
                                    <i class="fa fa-chart-line"></i>
                                    <span>{{ formatPercentage(item.calculated.roi ? item.calculated.roi : '0.00') }}</span>
                                </div>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
            <!-- <div class="d-flex justify-content-end align-items-center" style="margin-right: 40px">
                <div style="margin-right: 8px">
                    <select :value="filterParams.perPage" class="form-select" @change="SET_FILTER_PARAMS({ key: 'perPage', value: +$event.target.value })">
                        <option v-for="i in [10, 25, 50, 100]" :key="i" :value="i">{{ i }} {{ $t('views.products.perPage') }}</option>
                    </select>
                </div>
                <div>
                    <select :value="filterParams.page" class="form-select" @change="SET_FILTER_PARAMS({ key: 'page', value: +$event.target.value })">
                        <option v-for="n in totalPages" :key="n" :value="n" :selected="n === filterParams.page">{{ n }}. {{ $t('views.products.page') }}</option>
                    </select>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { countryInfo } from '@/utils/helper'
import moment from 'moment'
import InventoryClipboard from '../Inventory/InventoryClipboard.vue'
import ImagePlaceholder from '../Inventory/ImagePlaceholder.vue'
import { formatPercentage } from '@/utils/format-number'

const countries = countryInfo()

export default {
    name: 'ProductsTableList',
    components: { InventoryClipboard, ImagePlaceholder },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState('products', ['columns', 'filterParams', 'list', 'selectedRows', 'isLoadingList']),
        ...mapGetters({
            currentMarket: 'market/currentMarket',
            totalPages: 'products/totalPages',
        }),
        getAmazonCountryURL() {
            return countries[this.currentMarket.short].domain
        },
        getColumns() {
            return this.columns
        },
    },
    data() {
        return { countries, moment, formatPercentage }
    },
    mounted() {
        window.addEventListener('scroll', () => {
            const tableEment = document.querySelector('.custom-table-items')
            if (tableEment && window.scrollY > tableEment.offsetTop && window.innerWidth > 768) {
                document.body.classList.add('is-sticky')
            } else {
                document.body.classList.remove('is-sticky')
            }
        })
    },
    methods: {
        ...mapMutations('products', ['SET_SELECTED_ROW', 'SET_SELECTED_ALL_ROWS', 'SET_FILTER_PARAMS']),
        formatNumber(number) {
            if (number === null || number === undefined) return null

            const factor = Math.pow(10, 2)
            const rounded = Math.floor(number * factor + 1e-9) / factor
            return rounded.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },
        handleScroll() {
            document.querySelectorAll('.popper').forEach((element) => {
                element.style.cssText = 'display: none !important'
            })
        },
    },
}
</script>
<style lang="scss" scoped>
:root {
    --inventory-gray: #f8fafd;
    --inventory-primary: #ffb53e;
}

body.is-sticky {
    .custom-table-items {
        overflow: visible;
    }
}

.custom-table-items {
    max-width: 100% !important;
    overflow: visible;

    table {
        thead {
            top: 0;
            position: sticky;
        }
    }

    tr {
        border-bottom: 1px solid #e7eaf3b2;
        border-left: none !important;
    }
    td {
        vertical-align: middle;
        height: 100px;
        color: #677788 !important;
        font-size: 0.8rem;
        font-weight: 400;
        z-index: 0;
        background-color: #ffffff;

        strong {
            color: #00203f;
            font-weight: 600;
        }

        .status {
            color: #fff;
            font-size: 10.5px;
            font-weight: 700;
            line-height: 12.71px;
            padding: 3.67px 5.33px 3.67px 6.81px;
            border-radius: 5px;

            &.Pending {
                background-color: #ffb53e;
            }
            &.Unshipped {
                background-color: #00203f;
            }
            &.PartiallyShipped {
                background-color: #00c9a7;
            }
            &.Shipped {
                background-color: #00c9a7;
            }
            &.Canceled {
                background-color: #00203f;
            }
            &.Unfulfillable {
                background-color: #f5ca99;
            }
            &.InvoiceUncorfirmed {
                background-color: #ed4c78;
            }
            &.PendingAvailability {
                background-color: #ffb53e;
            }
            &.Refunded {
                background-color: #ed4c78;
            }
            &.Replacement {
                background-color: #677788;
            }
        }
    }
}
.thead-light {
    th {
        background-color: var(--inventory-gray) !important;
        border-bottom: 1px solid #e7eaf3b2 !important;
        color: #677788 !important;
        font-size: 11.9px !important;
        font-weight: 400 !important;
        line-height: 17.85px;
        font-weight: bold !important;
    }

    td {
        height: 58.5px !important;
    }
}
.table-checkbox {
    max-width: 25px;

    input:not(:checked) {
        border: 1px solid #677788;
    }
}
.text-ellipsis {
    font-size: 11.9px;
    font-weight: 400;
    line-height: 17.9px;
    color: #677788;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    &.title {
        max-width: 250px;
    }

    &.category {
        max-width: 125px;
    }
}
</style>
